var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.333 8a.167.167 0 00.167-.167V4.5h3.333A.167.167 0 008 4.333v-.666a.167.167 0 00-.167-.167H4.5V.167A.167.167 0 004.333 0h-.666A.167.167 0 003.5.167V3.5H.167A.167.167 0 000 3.667v.666c0 .092.075.167.167.167H3.5v3.333c0 .092.075.167.167.167h.666z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/6df25adf852a45e63366cbd18cf150e7-accordian.svg";
export { SvgAccordian as ReactComponent };